<div>
  <div class="search-container">
    <div class="input-actions">
      <div class="input-container">
        <input
          type="text"
          [(ngModel)]="searchTerm"
          (input)="applyFilter()"
          id="searchInput"
          [ngClass]="{ filled: searchTerm }"
        />
        <label for="searchInput"><span>{{ labelForSearch }}</span></label>
        @if (isBusy) {
          <span class="search-spinner" aria-label="Buscando"></span>
        }
      </div>

      @if(editMode){
        <div class="buttons-div">
          <button (click)="onAdd()">{{ nameButton }}</button>
        </div>
      }
    </div>
  </div>
  @if (filterData.length) {
    <div class="table-wrapper" [class.is-busy]="isBusy">
      <table>
        <thead>
          @for (col of columns; track col.key) {
            <th>{{ col.displayName }}</th>
          }
        </thead>
        <tbody>
          @for (item of paginatedData; track trackByIds($index, item)) {
            <tr>
              <!-- <td class="selection-cell">
                <input
                  type="checkbox"
                  [checked]="isSelected(item)"
                  (change)="toggleSelectItem(item)"
                  style="accent-color: var(--primaryColor)"
                />
              </td> -->
              @for (col of columns; track col.key) {
                <td>
                  @switch (col.key) { @case ('acciones') {
                    <div class="actions-cell">
                      @for (icon of actionsIcons; track icon.label) {
                      <button (click)="icon.action(item)" title="{{ icon.label }}" class="icon-button">
                        <img
                          src="/assets/icons/{{ icon.icon }}"
                          alt="{{ icon.label }}"
                          width="20"
                          height="20"
                        />
                      </button>
                      }
                      <button (click)="editar(item)" title="Editar">
                        <img
                          src="/assets/icons/edit.svg"
                          alt="Editar"
                          width="15"
                          height="15"
                        />
                      </button>
                      @if(editMode){
                      <button (click)="onDelete(item)" title="Eliminar">
                        <img
                          src="/assets/icons/delete.svg"
                          alt="Eliminar"
                          width="24"
                          height="24"
                        />
                      </button>
                      }

                      <!-- Botón para mostrar menú -->
                      @if(menu){
                      <div class="dropdown-wrapper">
                        <button
                          (click)="toggleMenu(item, $event); $event.stopPropagation()"
                          title="Más acciones"
                          class="menu-button"
                        >
                          <img
                            src="/assets/icons/Menu.svg"
                            alt="Más"
                            width="20"
                            height="20"
                          />
                        </button>

                        <!-- Menú desplegable -->
                        @if(item === currentMenuItem){
                        <div class="dropdown-menu" [ngClass]="{'up': menuPosition === 'up'}" (click)="$event.stopPropagation()">
                          <ul>
                            @for (option of options; track option){
                            <li (click)="onOptionClick(option, item)">
                              {{ option.label }}
                            </li>
                            }
                          </ul>
                        </div>
                        }
                      </div>
                      }
                    </div>
                  } @case ('activo') {
                    <label class="switch">
                      <input type="checkbox" [(ngModel)]="item.activo" />
                      <span class="slider"></span>
                    </label>
                  } @default {
                    @if (col.isLink) {
                      <a [routerLink]="[col.routeBase, item[col.key]]">
                        {{ displayValue(item, col) }}
                      </a>
                    } @else {
                      {{ displayValue(item, col) }}
                    }
                  }
                }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    @if (filterData.length > 0) {
        <div class="pagination-footer">
          <div class="page-size-group">
            <label for="itemsPerPage">Por página</label>
            <select
              id="itemsPerPage"
              [(ngModel)]="itemsPerPage"
              (change)="onItemsPerPageChange()"
            >
              <option [value]="5">5</option>
              <option [value]="10">10</option>
              <option [value]="25">25</option>
              <option [value]="50">50</option>
            </select>
        </div>

          <span class="pagination-info">
          {{ (currentPage - 1) * itemsPerPage + 1 }}–{{ getEndItemIndex() }} de {{ totalItems }}
        </span>

          <div class="pagination-buttons">
            <button (click)="previousPage()" [disabled]="currentPage === 1">
              <img src="assets/botones-footer-table/anterior.svg" alt="Anterior">
            </button>
            <button (click)="nextPage()" [disabled]="currentPage === totalPages">
              <img src="assets/botones-footer-table/siguiente.svg" alt="Siguiente">
            </button>
          </div>
        </div>
    }
  }
  @if (!filterData.length && !isBusy) {
    <div class="no-data"><span>No se encontraron registros</span></div>
  }
</div>
